import React, { useEffect, useState } from "react";
import Bank from "../../../assets/images/bank.png";
import Upi from "../../../assets/images/upi.png";
import Paytm from "../../../assets/images/paytm.png";
import Amazon from "../../../assets/images/amazon.png";
import Upilinkedmobno from "../../../assets/images/Upilinkedmobno.png";
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate, useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
import Header from "../../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { fetchAPI } from "../../service/Encrtyption";
import { claimStatus, myRewards, rewardMoney } from "../../auth/redux/store";


const paymentCardClass = (selected, item) =>
  `card paymentSelectCard${selected === item ? " paymentSelectCard--selected activeCard" : ""}`;

const PaymentOptionCard = ({ item, selected, onSelect, children }) => (
  <div
    className={paymentCardClass(selected, item)}
    onClick={() => onSelect(item)}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onSelect(item);
      }
    }}
    role="button"
    tabIndex={0}
    aria-pressed={selected === item}
  >
    <div className="card-body">{children}</div>
  </div>
);

export const SelectPayment = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams(); 
  const currentLanguage = lang;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const user = useSelector((state) => state?.user);
  const mobileNumber = sessionStorage.getItem('mbn');
  const [errroMsg, setErrorMsg] = useState("");
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const isreclaim = searchParams.get("isreclaim");
  const amount = useSelector((state) => state.amount);
  const browserType = sessionStorage.getItem("browserName") || "web"; 


  // const getCashbackFromSeedTransaction = (st) => {
  //   if (!st || typeof st !== "object") return 0;
  //   const claims = Array.isArray(st.dsrClaimList) ? st.dsrClaimList : [];
  //   const sum = claims.reduce(
  //     (total, claim) =>
  //       total + (parseFloat(claim.amount ?? claim.cashRewards) || 0),
  //     0
  //   );

  //   if (sum > 0) return sum;
  //   const apiTotal = parseFloat(st.totalCashbackWon);
  //   return !Number.isNaN(apiTotal) && apiTotal > 0 ? apiTotal : 0;
  // };


  const getCashbackFromSeedTransaction = (st) => {
    if (!st || typeof st !== "object") return 0;

    // If reclaim
    if (isreclaim) {
      // debugger;
      return amount;  

      // const reclaimList = Array.isArray(st.dsrReClaimList)
      //   ? st.dsrReClaimList
      //   : [];

      // return reclaimList.reduce(
      //   (total, item) =>
      //     total + (parseFloat(item.amount) || 0),
      //   0
      // );
    }

    // Normal claim
    const claims = Array.isArray(st.dsrClaimList)
      ? st.dsrClaimList
      : [];

    const sum = claims.reduce(
      (total, claim) =>
        total + (parseFloat(claim.amount ?? claim.cashRewards) || 0),
      0
    );

    if (sum > 0) return sum;

    const apiTotal = parseFloat(st.totalCashbackWon);

    return !Number.isNaN(apiTotal) && apiTotal > 0
      ? apiTotal
      : 0;
  };

  const obj = {
    cashFreeTransactionId: 0,
    dsrId: 0,
    ecouponFarmerMapId: 0,
    moduleType: "Farmer",
    programId: 0,
    reClaim: "No",
    showView: false,
    countOfToBeClaims: 0,
    dsrProgramId: 0,
    ecouponFarmerId: 0,
    enableSprayService: false,
    isCortevaProduct: false,
    isLumivia: false,
    isProductAlreadyScaned: false,
    isSpinDone: false,
    lumiviaServReqRecordID: 0,
    multipleRewards: false,
    seadProgramId: 0,
    showClickableLink: false,
    showLuckyWinnerPopup: false,
    showRetailerIdPopup: false,
    uq_responseCode: 0,
    wheelStoppingIndex: 0,
    destinationURL: "/cashFreeReward/getCashFreeTransactionPendingRequest_V2",
    appLangCode: currentLanguage
  };

  const [formData, setFormData] = useState(obj);


  const onSubmit = async () => {
    // debugger;
    setLoading(true);
    // console.log(JSON.stringify(formData) + "requestdata for claimlist");

    if (!mobileNumber) {
      setErrorMsg(t("sessionExperied"));
      setTimeout(() => {
        navigate(`/${lang}/giftHistory`);
      }, 2000);
      return;
    }

    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        formData,
        {
          mobileNumber: mobileNumber,
          appLangCode: currentLanguage,
          deviceType: "web",
          browserType: browserType,
        }
      );
      const jsonReposneData = JSON.parse(responseData);
      const programTitle = jsonReposneData.cashFreeTransactionList.programTitle;
      console.log(JSON.stringify(jsonReposneData) + "cashFreeTransactionList jsonReposneData");
      const st = jsonReposneData?.dsrTransactionList;
      const claimListAmount = getCashbackFromSeedTransaction(st);
      dispatch(rewardMoney(claimListAmount));
      // console.log(claimListAmount + " amount in claim list"); 
      // console.log((JSON.stringify(jsonReposneData.dsrTransactionList.claimList)) + "amount in claim list");
      // setProgramName(programTitle);
      // console.log(programTitle + "programName");
      setData(jsonReposneData);
      dispatch(myRewards(jsonReposneData));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Set loading state to false after API call is completed
    }
  };

  useEffect(() => {
    onSubmit();
  }, []);


  const myRewardsData = useSelector((state) => state.myRewardsData);
  const viewPaymentOptions = myRewardsData?.dsrTransactionList?.paymentOptions;
  const claimListAmount = getCashbackFromSeedTransaction(myRewardsData?.dsrTransactionList);
  const reclamDataObj = myRewardsData?.dsrTransactionList?.dsrReClaimList;

  const [selectedPayment, setSelectedPayment] = useState("");


  const handleContinue = () => {
    if (!selectedPayment) return;

    if (isreclaim) {
      if (reclamDataObj && reclamDataObj.length > 0) {
        dispatch(claimStatus(false));
      } else {
        dispatch(claimStatus(true));
      }
    } else {
      dispatch(claimStatus(true));
    }

    ReactGA.event({
      category: "Payment Method",
      action: "CONTINUE_BTN_CLICK",
      label: selectedPayment,
    });

    switch (selectedPayment.toLowerCase()) {

      case "bank details":
        navigate(`/${lang}/bankdetails?isreclaim=${isreclaim}`);
        break;

      case "upi":
      case "upilinkedmobno":
        navigate(`/${lang}/upidetails?isreclaim=${isreclaim}`, {
          state: { type: selectedPayment },
        });
        break;

      case "paytm":
        navigate(`/${lang}/paytmdetails?isreclaim=${isreclaim}`);
        break;

      case "amazon pay gift card":
        navigate(`/${lang}/paytmdetails?isreclaim=${isreclaim}`);
        break;

      default:
        alert("Invalid payment method");
    }
  };


  // const handleBankClick = () => {
  //   // debugger;
  //   ReactGA.event({
  //     category: 'User Bank Payment',
  //     action: 'CLK_BANK_MODE'
  //   });
  //   navigate(`/${lang}/bankdetails`);
  // }

  // const handleUPIClick = (type) => {
  //   ReactGA.event({
  //     category: 'btn',
  //     action: 'UPI_payment_mode_clicked',
  //     label: 'select_payment_method'
  //   });
  //   navigate(`/${lang}/upidetails`, {
  //     state: { type }
  //   });
  // };

  return (
    <>
      <Header navbarWhite={true} />
      <div className="main">
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            {/* <Accordion.Header id="transfer">
              <div>
                <i
                  className="fa fa-chevron-left text-white mr-2"
                  onClick={() => navigate(`/${lang}/home`)}
                ></i>
                {t("transfer")}
              </div>
            </Accordion.Header> */}

            <div className="card-body px-2 pt-0 pb-2 selectPaymentBody">
              <div className="px-4 py-2 mt-4">

                <div className="d-flex justify-content-center align-items-center flex-wrap mb-0">
                  <span
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: 600,
                      color: "#000000",
                      marginRight: "0.5rem",
                    }}
                  >
                    {t("selectPayment.cashbackAmountLabel")}
                  </span>
                  <span
                    className="text-secondaryColor font-bold"
                    style={{ fontSize: "1.875rem", lineHeight: 1.1 }}
                  >
                    ₹ {amount ? amount : claimListAmount}
                    {/* {(() => {
                      const n = Number(claimListAmount);
                      if (!Number.isFinite(n)) return 0;
                      return n % 1 === 0 ? n : n.toFixed(2);
                    })()} */}
                  </span>
                </div>

                <div className="mt-5 space-y-2">


                  {viewPaymentOptions?.map(
                    (item, index) =>
                      item.toLowerCase() === "bank details" && (
                        <div
                          key={index}
                          className={paymentCardClass(selectedPayment, item)}
                          onClick={() => setSelectedPayment(item)}
                        >
                          <div className="card-body">
                            <div className="d-flex align-items-center gap-6">
                              <img src={Bank} alt="Bank"

                              />
                              <h5 className="paymentSelectioText mb-0">
                                {t("selectPayment.bankDetails")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      )
                  )}



                  {
                    viewPaymentOptions?.map(
                      (item, index) =>
                        item.toLowerCase() === "upi" && (
                          <div
                            key={index}
                            className={paymentCardClass(selectedPayment, item)}
                            onClick={() => setSelectedPayment(item)}
                          >
                            <div className="card-body">
                              <div className="d-flex align-items-center gap-6">
                                <img
                                  src={Upi}
                                  alt="Upi"
                                  className="paymentOptionImg"
                                  style={{
                                    width: 80,
                                    border: "2px solid #d4d4d4",
                                    borderRadius: 10,
                                    padding: "0.5rem",
                                  }}
                                />
                                <h5 className="paymentSelectioText mb-0">
                                  {t("selectPayment.upi")}
                                </h5>
                              </div>
                            </div>
                          </div>
                        )
                    )
                  }


                  {
                    viewPaymentOptions?.map(
                      (item, index) =>
                        item.toLowerCase() === "paytm" && (
                          <div
                            key={index}
                            className={paymentCardClass(selectedPayment, item)}
                            onClick={() => setSelectedPayment(item)}
                          >
                            <div className="card-body">
                              <div className="d-flex align-items-center gap-6">
                                <img src={Paytm} alt="Paytm" />
                                <h5 className="paymentSelectioText mb-0">
                                  पेटीएम
                                </h5>
                              </div>
                            </div>
                          </div>
                        )
                    )
                  }



                  {
                    viewPaymentOptions?.map(
                      (item, index) =>
                        item.toLowerCase() === "amazon pay gift card" && (
                          <div
                            key={index}
                            className={paymentCardClass(selectedPayment, item)}
                            onClick={() => setSelectedPayment(item)}
                          >
                            <div className="card-body">
                              <div className="d-flex align-items-center gap-6">
                                <img src={Amazon} alt="Amazon Pay Gift Card" />
                                <h5 className="paymentSelectioText mb-0">
                                  एमाज़न पे गिफ्ट कार्ड
                                </h5>
                              </div>
                            </div>
                          </div>
                        )
                    )
                  }




                  {
                    viewPaymentOptions?.map(
                      (item, index) =>
                        item.toLowerCase() === "upilinkedmobno" && (
                          <div
                            key={index}
                            className={paymentCardClass(selectedPayment, item)}
                            onClick={() => setSelectedPayment(item)}
                          >
                            <div className="card-body">
                              <div className="d-flex align-items-center gap-6">
                                <img
                                  src={Upilinkedmobno}
                                  alt="Upilinkedmobno"
                                  className="paymentOptionImg"
                                  style={{
                                    width: 80,
                                    border: "2px solid #808080",
                                    borderRadius: 10,
                                    padding: "0.5rem",
                                  }}
                                />
                                <h5 className="paymentSelectioText mb-0">
                                  {t("upiLinkedMobileNumber")}
                                </h5>
                              </div>
                            </div>
                          </div>
                        )
                    )}

 
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="selectPaymentFooter">
          <button
            type="button"
            className="btn btn-secondary  submitBtn  w-100 btnshadow py-2 center-textbtn text-white"
            onClick={handleContinue}
            disabled={!selectedPayment || loading}
            aria-disabled={!selectedPayment || loading}
          >
            {t("selectPayment.proceedButton")}
          </button>
        </div>
      </div>
    </>
  );
};
